import { authenticatedApiCall } from '@/api/authenticatedApiCall.js'

export const getPatientReferrals = async () => {
  const url = '/v6/element/event/plan'

  const response = await authenticatedApiCall({ url })

  if (response.data.status !== 'ok') {
    throw new Error(response.data)
  }

  return response.data.data
}
